const tr = {
  stationReport: {
    title: 'Relatório Station',
    attributes: {
      id: 'ID',
      name: 'Nome',
      cpf: 'CPF',
      cell_phone: 'Telefone',
      email: 'E-mail',
      corporation: 'Empresa',
      complete_signup: 'Cadastro completo',
      cns: 'CNS',
      created_at: 'Data de Cadastro',
    },
    extras: {
      search: 'Digite o nome ou CPF',
    },
    defSingular: 'Relatório Station',
  },
};

export default tr;
